import moment from "moment";
import React, { useState, useEffect } from "react";
import { apiCall } from "../../utils/Api";
import { Button, Divider, Skeleton } from "antd";
import Html from "../../utils/Html";
import EventUI from "./EventUI";

export default function Upcoming(props) {


    const [results, setResults] = useState({ rows: [] });


    const {
        text_colour = 0,
        date_colour = 0,
        highlight_colour = 0,
        title_preset = 0,
        description_preset = 0,
        date_preset = 0,
        limit = 2,
        button_label = "",
        button_type = 0,
        button_align = "center",
        link_id = 0,
        categories = [],
        view = "desktop"
    } = props

    const fetchEvents = () => {
        if(window.sitesettings.using_events_v2){

            let obj = {
                start_date: moment().tz('America/Los_Angeles').format("YYYYMMDD"), limit: limit
            }

            if(categories){
                obj.categories = JSON.stringify(categories.map(item => item.id))
            }

            apiCall("event/v2/list", obj, (_status, _result) => {
                if (_status) {
                    setResults(_result)
                } else {
                    console.log(_result.error)
                }
            }, "customer")
        } else {
            apiCall("event/getList", { from: moment().tz('America/Los_Angeles').format("YYYYMMDD") }, (_status, _result) => {
                if (_status) {
                    setResults(_result)
                }
            }, "customer")
        }
    }

    useEffect(fetchEvents, [categories]);


    const drawEvents = () => {

        if(results.rows.length === 0){
           return Array.from(Array(limit).keys()).map((item, index) => {
                return <div key={index}><Skeleton /><Divider dashed /></div>
            })
        }

        return results.rows.slice(0, limit).map((item, index) => {
            return (
                <>
                    <EventUI
                        view={view}
                        link_id={link_id}
                        flourish
                        text_colour={text_colour}
                        date_colour={date_colour}
                        highlight_colour={highlight_colour}
                        event={item}
                        title_preset={title_preset}
                        date_preset={date_preset}
                        description_preset={description_preset}
                    />
                    
                    <Divider dashed />
                </>
            )
        })
    }

    const draw = () => {

        return (
            <>
                {drawEvents()}

                {((button_label) && <>
                    <div style={{ "display": "block", "textAlign": button_align }}>
                        <Button className={"bm-btn-" + button_type}>{button_label}</Button>
                    </div>

                </>)}

            </>
        )
    }


    return draw();


}